import InfoOutlined from "@mui/icons-material/InfoOutlined";
import type { FC } from "react";
import { EmptyState } from "../../../../../components/UIToolkit/molecules/EmptyState";

type Props = { title: string; hint: string; testId: string };

export const EmptySummaryState: FC<Props> = ({ title, hint, testId }) => <EmptyState icon={<InfoOutlined />} title={title} hint={hint} dataTestId={testId} />;
